<template>
  <div id="index-slider">
    <el-card style="border-radius: 8px;height: 215px" :body-style="{padding:'0px'}">
      <el-carousel :interval="8000" height="215px">
        <el-carousel-item
          style="border-radius: 8px"
          v-for="(item, index) in module.contentpageslideshow_datas"
          :title="item.title"
          :key="index"
          :data-skip_id="item.skip_id"
          :data-skip_web_content="item.skip_web_content">
          <router-link
            v-if="item.skip_type===1"
            :to="{path: '/video/course_id/'+item.skip_id}">
            <img :src="item.web_imageurl" class="banner_img" id="bannerImg">
          </router-link>
          <a style="font-size: 12px;color: #BDBDBD" :href="item.skip_web_content">
            <img :src="item.web_imageurl" class="banner_img" id="bannerImg2">
          </a>
        </el-carousel-item>
      </el-carousel>
    </el-card>
    <!--头条资讯-->
    <div style="display: flex;flex-direction: row">
      <el-card style="border-radius: 8px;height: 375px;" :body-style="{padding:'0px'}">
        <el-aside width="150px">
          <el-menu v-for="(item, index) in tagList" :key="item.id" :default-active="localTag" @select="onSelect"
                   style="margin-top: 0;">
            <el-menu-item class="title" :index="item.name" route="">{{ item.name }}</el-menu-item>
          </el-menu>
        </el-aside>
      </el-card>
      <el-card style="border-radius: 8px;height: 375px;margin-left: 30px;width: 100%" :body-style="{padding:'0px'}">
        <div class="cf-title cf">
          <div class="cf-title-line"/>
          <label>头条资讯</label>
          <router-link style="margin-left: auto;margin-right: 10px;color: #999999" :to="{path: '/information' }">
            查看更多
          </router-link>
        </div>
        <el-scrollbar style="height: 375px;" :native="false" wrapStyle="" wrapClass="" viewClass="" viewStyle=""
                      :noresize="false" tag="section">
          <div v-for="(item, index) in zxList">
            <a :title="item.title" target="_blank" v-on:click="toArticle(item)">
              <div :class="index % 2 === 0 ? 'info_title' : 'info_title2'">
                <h3 v-if="item.show_top_data === 1" style="margin-left: 20px;color: darkred">{{
                    "[置顶] " + item.title
                  }}</h3>
                <h3 v-if="item.show_top_data === 0" style="margin-left: 20px;color: #333333">{{ item.title }}</h3>
                <div style="color: #666666;margin-left: auto">{{ item.created_at }}</div>
              </div>
            </a>
          </div>
        </el-scrollbar>

      </el-card>
    </div>
  </div>
</template>
<script>

import {api_info_article, info_main} from "../../networks/InfoArticleHandler.js"

export default {
  name: "index-carousel",
  props: ['module'],
  data() {
    return {
      zxList: [],
      tagList: [],
      localTag: '公考资讯',
      localAreaId: 6,
    }
  },
  created: function () { //-------------------- 获取资讯列表
    var context = this;
    var promise = info_main();
    promise.then(function (r) {
      context.tagList = r.categories;
      context.zxList = r.categories[0].articles;
    }).catch(function (error) {
    });
  },
  methods:{
    onSelect: function (index, indexPath) {
      let context = this;
      context.localTag = index;
      context.localNum = 1;
      var index = context.tagList.findIndex(item => item.name === index)
      context.getArticleList(context.tagList[index].id, 1)
    },
    getArticleList: function (category_id, pageNum) {
      var context = this;
      var promise = api_info_article(category_id, pageNum, context.localAreaId);
      promise.then(function (r) {
        context.zxList = r.articles;
        // var doc = document.body.scrollTop == 0 ? $(document.documentElement) : $('body');
        // doc.animate({'scrollTop': 0});
      }).catch(function (error) {
      });
    },
  }
}
</script>

<style scoped>

@import "../../common/style/classsection.css";

ul {
  padding-left: 0;
  margin: 0;
}

.banner_img {
  border-radius: 8px !important;
  height: 215px;
  width: 100%;
  object-fit: fill;
}

ul li {
  list-style-type: none;
  margin-bottom: 5px;
}

.info_top {
  color: darkred;
  font-weight: 500;
  font-size: 18px;
  padding: 10px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  padding-right: 10px;
  list-style: none;
}

.area_text_non {
  width: 50px;
  text-align: center;
}

.area_text {
  font-weight: bold;
  width: 50px;
  text-align: center;
  color: #ffbc42;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/IndexCarousel.vue